<div class="overview">
  <div class="overview__main">
    <div class="overview__header">
      <div class="overview__name-review">
        <h1 class="overview__header-text">
          {{ business.name }}
          <mat-icon (click)="openEditContactDialog()" *ngIf="editModeSet && !isAmbassador && !isRegionalManager" class="edit-icon">edit</mat-icon>
        </h1>
        <h2 class="overview__header-subtext" *ngIf="business.doBusAs">{{ business.doBusAs }}</h2>
        <app-review-overview class="overview__reviews" [reviewSummary]="business.reviewSummary"></app-review-overview>
      </div>
    </div>
    <div class="business-overview__subheader">
      <app-address *ngIf="business.address" [address]="business.address" class="overview__address"></app-address>
      <div *ngIf="business.phone">Phone: {{ business.phone | phone }}</div>
      <div *ngIf="business.fax">Fax: {{ business.fax | phone }}</div>
      <div *ngIf="business.webAddress">
        Website:
        <a class="overview__website" href="{{ BusinessWebAddress }}" target="_blank">{{ business.webAddress }}</a>
      </div>
      <div *ngIf="business.email">
        Email:
        <a class="overview__website" href="{{ BusinessEmailAddress }}" target="_blank">{{ business.email }}</a>
      </div>
      <div *ngIf="!isFlyingClub && adminDate">
        <i>Business Listing Last Verified: {{getAdminDate()}}</i>
      </div>
      <div *ngIf="isFlyingClub && adminDate">
        <i>Club Listing Last Verified: {{getAdminDate()}}</i>
      </div>
      <div *ngIf="!isFlyingClub">
        <a (click)="navigateToWebcams()" mat-button
           class="business-overview__action aopa-mat-btn aopa-mat-btn--filled">
          Webcams ({{ this.business.webcams.length }})
        </a>
        <div>
          <button class="mat-button aopa-mat-btn aopa-mat-btn--filled suggest-a-change" (click)="openSuggestAChangeDialog()">Suggest a Change to this Page</button>
        </div>
      </div>
    </div>
    <div *ngIf="isBusinessManager && editModeSet; else businessAlert" class="overview__alert">
      <div class="overview__alert-header">
        <mat-icon class="overview__alert-icon">info</mat-icon>
        <div class="overview__alert-header-text">Verify this listing</div>
      </div>
      <div class="overview__alert-body">
        <p>
          Check the box below if all the information on this listing is correct to the best of your knowledge.
        </p>
        <p>
          <i>Please review this listing often and check the box to set a new verified date</i>
        </p>
        <div class="check-box">
          <mat-checkbox (change)="checkBoxChanged($event)"><strong>Verify Listing</strong></mat-checkbox>
        </div>
        <p *ngIf="adminDate">Last Verified: {{getAdminDate()}}</p>
      </div>
    </div>
    <button *ngIf="(isFbo || isFlightSchool) && (isBusinessManager && editModeSet)" class="mat-button aopa-mat-btn aopa-mat-btn--filled suggest-a-change" (click)="openSelectMagDialog()">Select Complimentary Magazine</button>
  </div>
  <div *ngIf="showMap || editModeSet" class="overview__chart-container">
    <div class="overview__chart-wrapper">
      <agm-map #map class="overview__chart" [zoom]="this.isFlyingClub ? 15 : 17" [usePanning]="true"
               [mapTypeControl]="true" [fullscreenControl]="true"
               [mapTypeId]="this.isFlyingClub ? 'satellite' : 'roadmap'"
               [mapTypeControlOptions]="{ position: 6, mapTypeIds: [ 'roadmap', 'satellite' ]}" >
        <agm-marker *ngIf="latlon" [latitude]="latlon.lat"
                    [longitude]="latlon.lon"
                    [markerDraggable]="editModeSet && !isAmbassador" (dragEnd)="pinDropped($event)"></agm-marker>
      </agm-map>
      <div class="overview__chart-legend">
        <div *ngIf="latlonApprox">
          Location is approximate based on street address. This business has not yet given AOPA its exact location.
        </div>
        <ng-container *ngIf="!editModeSet; else editModeDesc">
          <div *ngIf="business.locationDesc">
            Location: {{business.locationDesc}}
          </div>
        </ng-container>

      </div>
    </div>
  </div>
</div>
<ng-template #businessAlert>
  <div *ngIf="isBusinessManager; else nonManagerAlert">
    <a *ngIf="isFlyingClub; else notFlyingClub" (click)="openBlueBoxDialog('FlyingClubManager')" mat-button
       class="business-overview__bluebox aopa-mat-btn aopa-mat-btn--filled">
      <div class="business-overview__button-content">
        <span class="business-overview__button-top"><mat-icon class="business-overview__alert-icon-blue-box">info</mat-icon> <span>ATTENTION FLYING CLUB MANAGER</span></span>
        <span class="business-overview__button-line">Click for information on editing</span>
        <span class="business-overview__button-line">your flying club listing</span>
      </div>
    </a>
    <!-- <div class="overview__alert-header">
      <mat-icon class="overview__alert-icon">info</mat-icon>
      <div class="overview__alert-header-text" *ngIf="isFlyingClub; else notFlyingClubHeader">Attention Flying Club Manager:</div>
    </div> -->
    <!-- <div class="overview__alert-body">
      <p>
        You can edit the details on this page by enabling "Edit Mode" using the slider button that is above the
        business name.
      </p>
      <p>
        Each editable section will have a blue pencil icon next to it. Clicking the pencil icon will display
        options for updating, adding new or removing details in that section.
      </p>
      <p>
        If you need assistance, please contact us at:<br/>
        <strong>AOPA Airport Directory Support Team:</strong><br/>
        <strong>Email</strong>: <a href="mailto:airportdirectory@aopa.org">airportdirectory@aopa.org</a><br/>
        <strong>Phone</strong>: (888) 359-2672
      </p>
    </div> -->
  </div>
</ng-template>
<ng-template #editModeDesc>
  <ng-container *ngIf="!isAmbassador">
    Move pin to change location of business on map.
  </ng-container>
</ng-template>
<ng-template #nonManagerAlert>
  <div class="business-overview__alert" [style.visibility]="isFlyingClub ? 'hidden' : 'visible'">
    <a (click)="openBlueBoxDialog('ClaimManager')" mat-button
       class="business-overview__bluebox aopa-mat-btn aopa-mat-btn--filled">
      <div class="business-overview__button-content">
        <span class="business-overview__button-top"><mat-icon class="business-overview__alert-icon-blue-box">settings</mat-icon> <span>MANAGE THIS BUSINESS?</span></span>
        <span class="business-overview__button-line">Log in or click here to claim this business</span>
      </div>
    </a>
    <br /><br />
    <!-- <a (click)="openBlueBoxDialog('ReportIssue')" mat-button
       class="business-overview__bluebox aopa-mat-btn aopa-mat-btn--filled">
      <div class="business-overview__button-content">
        <span class="business-overview__button-top"><mat-icon class="business-overview__alert-icon-blue-box">info</mat-icon> <span>REPORT A PROBLEM WITH THIS PAGE</span></span>
      </div>
    </a> -->
    <!-- <div class="overview__alert-header">
      <mat-icon class="overview__alert-icon">info</mat-icon>
      <div class="overview__alert-header-text">Manage this business or want to suggest a change?</div>
    </div>
    <div class="overview__alert-body">
      <p>
        If you manage this business, please contact our Airport Directory Support Team for
        information on how to claim your business so you can make updates. If you want to suggest a change to our
        information, we'll be happy to verify the details and update the page as needed.
      </p>
      <p>Please contact us at:<br/>
        <strong>AOPA Airport Directory Support Team:</strong><br/>
        <strong>Email:</strong> <a href="mailto:airportdirectory@aopa.org">airportdirectory@aopa.org</a><br/>
        <strong>Phone:</strong> (888) 359-2672
      </p>
    </div> -->
  </div>
</ng-template>
<ng-template #notFlyingClub>
  <a (click)="openBlueBoxDialog('BusinessManager')" mat-button
     class="business-overview__bluebox aopa-mat-btn aopa-mat-btn--filled">
    <div class="business-overview__button-content">
      <span class="business-overview__button-top"><mat-icon class="business-overview__alert-icon-blue-box">info</mat-icon> <span>ATTENTION BUSINESS MANAGER</span></span>
      <span class="business-overview__button-line">Click for information on editing</span>
      <span class="business-overview__button-line">your business listing</span>
    </div>
  </a>
</ng-template>
